import React from 'react'
import { Controller } from 'react-hook-form'
import YumSwitch from '../YumSwitch/YumSwitch'

type YumFormSwitchProps = {
  name: string
  control: any
  disabled?: boolean
}

const YumFormSwitch = (props: YumFormSwitchProps) => {
  const { name, control, disabled } = props
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ref, ...field } }) => (
        <YumSwitch {...field} disabled={disabled} checked={!!value} inputRef={ref} />
      )}
    />
  )
}

export default YumFormSwitch
